import { Box, Grid, Skeleton, useTheme } from "@mui/material";
import { AppDocument } from "../../types";

const ImageSelector = ({
  images,
  loading,
  selectedImagesIds: selectedImagesIds,
  setSelectedImagesIds: setSelectedImagesIds,
}: {
  images: AppDocument[];
  loading?: boolean;
  selectedImagesIds: string[];
  setSelectedImagesIds: (docs: string[]) => void;
}) => {
  const toggleSelect = (img: AppDocument): void => {
    const next = selectedImagesIds.find((i) => i === img.uid)
      ? selectedImagesIds.filter((i) => i !== img.uid)
      : [...selectedImagesIds, img.uid];
    setSelectedImagesIds(next);
  };

  const t = useTheme();

  if (loading) return <Skeleton />;

  return (
    <Grid container spacing={2}>
      {images?.map((img) => {
        const index: number = selectedImagesIds.findIndex((i) => i === img.uid);
        const isSelected: boolean = index !== -1;

        return (
          <Grid size={3} key={img.id}>
            <Box
              onClick={() => toggleSelect(img)}
              sx={(t) => ({
                position: "relative",
                cursor: "pointer",
                borderRadius: t.nawy.radius.md,
                overflow: "hidden",
                border: isSelected
                  ? `2px solid ${t.nawy.colors.semantic.border.accent}`
                  : undefined,
                p: "2px",
              })}
            >
              <img
                src={img.fileUrl}
                alt={img.fileName}
                style={{
                  width: "100%",
                  height: "80px",
                  objectFit: "cover",
                  display: "block",
                  borderRadius: t.nawy.radius.sm,
                }}
              />
              {isSelected && (
                <Box
                  sx={(t) => ({
                    ...t.nawy.typography.english.variants.body.xs.regular,
                    position: "absolute",
                    top: 6,
                    right: 6,
                    width: 20,
                    height: 20,
                    borderRadius: t.nawy.radius.full,
                    backgroundColor: t.nawy.colors.semantic.layer.accent,
                    color: t.nawy.colors.semantic.text.onColor,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  })}
                >
                  {index + 1}
                </Box>
              )}
            </Box>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default ImageSelector;
